import { createComponent } from 'react-fela'

const baseProps = [
  'data-automation',
  'data-component',
  'data-cm-metadata',
  'data-testid',
  'data-content-id',
  'itemScope',
  'itemProp',
  'itemType',
  'alt',
  'displayName',
  'href',
  'key',
  'src',
  'target',
  'onClick',
  'onMouseEnter',
  'onMouseLeave',
  'onMouseOut',
  'hidden',
  'disabled',
  'dir'
]

export default (displayName, rule, type = 'div', passThroughProps = []) => {
  Object.defineProperty(rule, 'name', { value: displayName, configurable: true })
  const Component = createComponent(rule, type, [...baseProps, ...passThroughProps])
  return Component
}
